import { LocalizationProvider as I10nProvider } from '@im/react-localization';
import React, { ReactNode } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { useBuildVars, useSiteConfig } from '../config';
import { getSameOriginApiBasePath, useSameOriginApis } from '../query/utils';

type Props = {
  children: ReactNode;
};

const win = window as any;
const temp_session_Id = uuidV4();

const translationpreloadResourcesMap: {
  [appId: string]: { [environment: string]: string[] };
} = {
  cep: {
    development: ['Common', 'myprofile'],
    production: ['Common', 'myprofile'],
    productionbeta: ['Common', 'myprofile'],
    productionbetax: ['Common', 'myprofile'],
    staging: ['Common', 'myprofile'],
    staging2: ['*'],
  },
  x4ec: {
    development: ['Common'],
  },
};

const whitelistedCountries = ['us'];
const blacklistedEnvironments = ['development', 'production', 'staging2'];

export function LocalizationProvider(props: Props) {
  const { children } = props;

  const buildVars = useBuildVars();
  const siteConfig = useSiteConfig();

  // enable browser translation on staging2
  if (buildVars.buildEnvironment === 'staging2') {
    const elements = document.querySelectorAll('html,body');
    elements.forEach((element) => {
      element.removeAttribute('translate');
      element.classList.remove('notranslate');
    });
  }

  const dd_session_id =
    win.DD_RUM?.getInternalContext()?.session_id || temp_session_Id;

  const isNonProd =
    buildVars.buildEnvironment.startsWith('staging') ||
    buildVars.buildEnvironment === 'development';

  const apiBaseRoute =
    !blacklistedEnvironments.includes(buildVars.buildEnvironment) &&
    whitelistedCountries.includes(siteConfig.siteCode)
      ? buildVars.API_GCP_BASE
      : buildVars.API_BASE;
  const shouldUseSameOriginApis = useSameOriginApis();

  const url = `${
    shouldUseSameOriginApis() ? getSameOriginApiBasePath() : apiBaseRoute
  }/shared/v1/translations`;

  return (
    <I10nProvider
      apiHeaders={{ 'IM-DDSessionId': dd_session_id }}
      appId={buildVars.appId}
      defaultLocale={siteConfig.defaultLocale}
      preloadResources={
        translationpreloadResourcesMap[buildVars.appId][
          buildVars.buildEnvironment
        ]
      }
      showLogs={isNonProd}
      supportedLocales={siteConfig.supportedLocales}
      url={url}
      useApi={true}
    >
      {children}
    </I10nProvider>
  );
}
